export default __webpack_public_path__ + "static/media/apple-gray.e1122bc2.png";